/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-cinematic-section-authentication';
const prefix = `${moduleName}.${componentName}`;

export const samlLabel = `${prefix}.samlLabel`;
export const oAuthLabel = `${prefix}.oAuthLabel`;
export const jwtLabel = `${prefix}.jwtLabel`;
export const ntlmLabel = `${prefix}.ntlmLabel`;

export const ENGLISH = {
    [samlLabel]: 'SAML',
    [oAuthLabel]: 'OAuth',
    [jwtLabel]: 'JWT',
    [ntlmLabel]: 'NTLM',
};
